// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","mobileThreshold":"575px","button":"_2JtmVDW7dlC6yYNIkhaX_y","borderBlack":"#777777","customWhite":"#ffffff","textBlack":"#161616","borderGrey":"#d5dfdf","customGreyFaded":"#f7f9fc","container":"_2e3gTYLiqpZnoCzoK2SXrz","filterCard":"_1VcswhAT_VBkEPNjr6xl6S _2JtmVDW7dlC6yYNIkhaX_y","selected":"q3yqyChTLu6H-xSqhxegT"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-index/filters/Filters.css
// module id = 1054
// module chunks = 1